import MortgageContent from './components/MortgageContent/MortgageContent';
import MortgageRow from './components/MortgageRow/MortgageRow';
import MortgageTitle from './components/MortgageTitle/MortgageTitle';

import { DownloadBtn, SwiperCards } from '@/components/UI';
import { Main, SectionWrapper } from '@/components/layouts/Containers';

import {
  categoryData,
  easternHectareData,
  individualBuildingData,
  infoForBorrowers,
  meta,
} from './MortgageRules.data';

import styles from './MortgageRules.module.scss';

const MortgageRules = () => {
  return (
    <Main meta={meta}>
      <SectionWrapper>
        <h1 className={styles.titleHeader}>Правила выдачи ипотечного займа</h1>

        <MortgageRow>
          <MortgageTitle>
            <span>Информация для заемщиков</span>
          </MortgageTitle>

          <MortgageContent>
            {infoForBorrowers.map((item) => (
              <div className={styles.infoItem} key={item.title}>
                <p className={styles.itemTitle}>{item.title}</p>
                <DownloadBtn href={item.link} />
              </div>
            ))}
          </MortgageContent>
        </MortgageRow>
      </SectionWrapper>

      <SectionWrapper>
        <h2 className={`mb-6 ${styles.subTitle}`} id='individual-building'>
          Для индивидуального жилищного строительства
        </h2>

        <MortgageRow>
          <MortgageTitle>
            <span>Документы</span>
          </MortgageTitle>

          <MortgageContent>
            {individualBuildingData.map((item, index) => (
              <div className={styles.infoItem} key={index}>
                <p className={`mb-0 ${styles.itemTitle}`}>{item.title}</p>
                <span className={`mb-2 ${styles.description}`}>{item.text}</span>
                <DownloadBtn href={item.link} />
              </div>
            ))}
          </MortgageContent>
        </MortgageRow>
      </SectionWrapper>

      <SectionWrapper>
        <h2 className={`mb-6 ${styles.subTitle}`} id='eastern-hectare'>
          Дальневосточный гектар
        </h2>

        <MortgageRow>
          <MortgageTitle>
            <span>Документы</span>
          </MortgageTitle>

          <MortgageContent>
            {easternHectareData.map((item, index) => (
              <div className={styles.infoItem} key={index}>
                <p className={`mb-0 ${styles.itemTitle}`}>{item.title}</p>
                <span className={`mb-2 ${styles.description}`}>{item.text}</span>
                <DownloadBtn href={item.link} />
              </div>
            ))}
          </MortgageContent>
        </MortgageRow>
      </SectionWrapper>

      <SwiperCards list={categoryData} slideWidth={420} title='Другие разделы' />
    </Main>
  );
};

export default MortgageRules;
